<template>
  <div id="LandingLogin" class="row">
    <div class="overlay" @click="hide"></div>
    <div class="modal LoginModal">
      <div class="group">
        <b>{{ $t("Auth.EnterPhoneNumber") }}</b>
        <VuePhoneNumberInput
          v-model="phone"
          :default-country-code="selectedCountryIsoCode"
          :show-code-on-list="false"
          :translations="translations"
          :disabled="optForVerification"
          :border-radius="0"
          @update="countrySelectorCallback"
        />
        <!--
        <input
          type="tel"
          id="login"
          v-model="phone"
          :placeholder="$t('Customer.PhoneNumber')"
          :maxlength="Config.options.phone_max_length"
          :disabled="optForVerification"
        />
        -->
        <span class="text-danger" v-if="errors.length_error">
          {{ $t("LoginMaxLength") }}
          {{ Config.options.phone_max_length }}
        </span>
      </div>

      <div class="Verify" v-if="optForVerification">
        <div class="group">
          <b>{{ $t("EnterTheCode") }}</b>
        </div>

        <div class="code">
          <div style="display: flex; flex-direction: row">
            <v-otp-input
              ref="otpInput"
              input-classes="otp-input"
              separator="-"
              :num-inputs="6"
              :should-auto-focus="true"
              :is-input-num="true"
              :separator="false"
              @on-complete="verify"
            />
          </div>
          <!--
          <input
            type="text"
            :id="'code' + index"
            placeholder="-"
            v-for="index in 6"
            :key="index"
            maxlength="1"
            @keyup="nextNumber(index)"
          />
          -->
        </div>
        <div class="text-danger text-center mt-2" v-if="errors.wrong_code">
          {{ $t("WrongCode") }}
        </div>
      </div>

      <div class="footer">
        <div class="text" v-html="$t('LoginModalSpeech')"></div>
        <button
          class="btn"
          @click="login()"
          v-if="!loading && !optForVerification"
        >
          {{ $t("Auth.Login") }}
        </button>
 
      </div>
    </div>

    <div class="modal RegisterModal">
      <div class="group">
        <b>{{ $t("PleaseRegister") }}</b>

        <VuePhoneNumberInput
          v-model="registerForm.phone"
          :default-country-code="selectedCountryIsoCode"
          :show-code-on-list="false"
          :translations="translations"
          :disabled="optForVerification"
          :border-radius="0"
          @update="countrySelectorCallback"
        />
      </div>
      <div class="group mt-3">
        <b>{{ $t("FullName") }}</b>
        <input
          type="text"
          id="fullname"
          v-model="registerForm.name"
          :placeholder="$t('FullName')"
          minlength="3"
        />
      </div>
      <div class="group mt-3" v-if="Config.enable_email">
        <b>{{ $t("Email") }}</b>
        <input
          type="tel"
          id="login"
          v-model="registerForm.email"
          :placeholder="$t('Email')"
        />
      </div>
      <div class="group mt-3" v-if="Config.enable_social_reason">
        <b>{{ $t("SocialReason") }}</b>
        <input
          type="tel"
          id="login"
          v-model="registerForm.social_reason"
          :placeholder="$t('SocialReason')"
        />
      </div>
      <div class="group mt-3">
        <div class="d-flex justify-content-center">
        <vs-checkbox
          :id="'terms'"
          :vs-value="true"
          v-model="registerForm.terms"
        >
          {{ $t("AcceptTermsUrl") }}
        </vs-checkbox>
        <span @click="showPopupTerms" style="text-decoration: underline; color: var(--primary); cursor: pointer;">{{ $t("TermsUrl") }}</span>
      </div>
        <div class="text-danger mt-3 ml-1" v-if="checkTerms">
          {{ $t("ErrorCheck") }}
        </div>
      </div>

      <div class="footer">
        <button class="btn" @click="register()" v-if="!loading">
          {{ $t("Auth.CreateAnAccount") }}
        </button>
        <button class="btn" v-else>
          <font-awesome-icon class="icon spin-icon" icon="spinner" />
        </button>
      </div>
      <div class="text-danger text-center mt-3" v-if="errors.register">
        {{ $t("ErrorOccured") }}
      </div>
    </div>
    <PopupTerms
        :active="popupTerms.active"
        :type="popupTerms.type"
        :title="popupTerms.title"
        :message="popupTerms.message"
        :confirmationButton="popupTerms.confirmationButton"
        @closePopupTerms="closePopupTerms"
      />
  </div>
</template>

<script>
import $ from "jquery";
import { userService } from "/src/_services";
import PopupTerms from "../modals/PopupTerms.vue"

export default {
  data: () => ({
    translations: {
      countrySelectorLabel: "Code pays",
      countrySelectorError: "Choisir un pays",
      phoneNumberLabel: "Numéro de téléphone",
      example: "Exemple :",
    },
    loading: false,
    phone: "",
    phone_prefix: null,
    optForVerification: false,
    registerForm: {
      phone: "",
      name: "",
      email: "",
      social_reason: "",
      terms: false,
      error: false,
    },
    errors: {
      length_error: false,
      wrong_code: false,
      register: false,
    },
    checkTerms: false,
    validPhoneNumber: false,
    selectedCountryIsoCode: "TN",
    popupTerms: {
      active: false,
      type: "terms",
      title: "",
      message: "",
      confirmationButton: "",
    },
  }),
  components: {
    PopupTerms
  },
  mounted() {
    if (!this.Config.enable_social_reason) {
      this.registerForm.social_reason = "";
    }
  },
  methods: {
    closePopupTerms() {
      this.popupTerms.active = false;
    },
    showPopupTerms() {
      this.popupTerms.confirmationButton = this.$t('Company.Close');
      $("#PreLoader").show();
      userService.getTerms(this.Config.organization_id).then(function(res) {
        this.popupTerms.message = res.terms.content;
        this.popupTerms.active = true;
      }.bind(this)).catch(function() {
        this.popupTerms.message = this.$t('ErrorOccured');
        this.popupTerms.active = true;
      }.bind(this)).finally(function() {
        $("#PreLoader").hide();
      }.bind(this))
    },
    countrySelectorCallback(data) {
      this.phone_prefix = "+" + data.countryCallingCode;
      this.selectedCountryIsoCode = data.countryCode;
      this.validPhoneNumber = data.isValid;
    },
    /*
    loginWithTrueCaller(){
      let req_nonce = Date.now();  // random number of length 8 to 64 characters
      let link = "truecallersdk://truesdk/web_verify?"
                    +"requestNonce="+req_nonce
                    +"&partnerKey=MVxCx077b0db358a245e39c6a62f21c59bbb7"
                    +"&partnerName=MonRDV BIAT"
                    +"&lang=en"
                    +"&loginPrefix=continue"
                    +"&loginSuffix=loginsignup"
                    +"&ctaPrefix=continuewith"
                    +"&ctaColor=%23f75d34"
                    +"&ctaTextColor=%23f75d34"
                    +"&btnShape=round"
                    +"&skipOption=useanothernum"
      alert(link);
      window.location = link;
    },
    */
    verify(otp) {
      this.loading = true;
      let data = {
        phone: this.phone.toString().replace(/ /g, ""),
        phone_prefix: this.phone_prefix,
        code: otp,
      };
      userService
        .verify(data)
        .then(
          function (data) {
            localStorage.setItem("user", JSON.stringify(data.user));
            this.$router.go();
          }.bind(this)
        )
        .catch(
          function (ex) {
            this.errors.wrong_code = true;
            for (var i = 1; i <= 6; i++) {
              $("#code" + i).val("");
            }
            $("#code1").focus();
            this.loading = false;
            // this.loginError = true;
          }.bind(this)
        )
        .finally(function () {}.bind(this));
    },
    nextNumber(index) {
      let current_input = $("#code" + index).val();
      if (
        index < 6 &&
        current_input.length == 1 &&
        !isNaN(current_input) &&
        current_input >= 0 &&
        current_input <= 9
      ) {
        $("#code" + (index + 1)).focus();
      } else if (index != 6) {
        $("#code" + index).val("");
        $("#code" + index).focus();
      } else {
        this.verify();
      }
    },
    register() {
      if (this.registerForm.terms) {
        this.checkTerms = false;
        this.loading = true;
        this.errors.register = false;
        let data = {
          phone: this.registerForm.phone.toString().replace(/ /g, ""),
          phone_prefix: this.phone_prefix,
          fullname: this.registerForm.name,
          email: this.registerForm.email,
          country: this.selectedCountryIsoCode,
        };

        if (this.Config.enable_social_reason == true) {
          data.social_reason = this.registerForm.social_reason;
        }
        userService
          .register(data)
          .then(
            function () {
              this.phone = data.phone;
              $(".RegisterModal").fadeOut(
                "300",
                function () {
                  $(".LoginModal").fadeIn("300");
                  this.optForVerification = true;
                }.bind(this)
              );
            }.bind(this)
          )
          .finally(
            function () {
              this.loading = false;
            }.bind(this)
          )
          .catch(
            function () {
              this.errors.register = true;
            }.bind(this)
          );
      } else {
        this.checkTerms = true;
      }
    },
    login() {
      let data = {
        phone: this.phone.toString().replace(/ /g, ""),
        phone_prefix: this.phone_prefix,
      };
      if (this.validPhoneNumber == true) {
        this.loading = true;
        userService
          .login(data.phone, data.phone_prefix)
          .then(
            function (data) {
              this.optForVerification = true;
              $("#code1").focus();
              setTimeout(function () {
                $("#code1").focus();
              }, 300);
            }.bind(this)
          )
          .catch(
            function (ex) {
              this.registerForm.phone = this.phone;
              $(".LoginModal").fadeOut("300", function () {
                $(".RegisterModal").fadeIn("300");
              });
            }.bind(this)
          )
          .finally(
            function () {
              this.loading = false;
            }.bind(this)
          );
      } else {
        this.errors.length_error = true;
      }
    },
    show() {
      $("#LandingLogin").fadeIn("300");
    },
    hide() {
      $("#LandingLogin").fadeOut("300", function () {
        $(".LoginModal").fadeIn();
        $(".RegisterModal").fadeOut();
        $(".VerifyModal").fadeOut();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#LandingLogin {
  width: 100vw;
  height: 100vh;
  min-height: -webkit-fill-available;
  overflow-x: hidden !important;
  overflow-y: hidden !important;
  position: absolute;
  top: 50%;
  margin: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999999990;

  display: none;
  .overlay {
    width: 100vw;
    height: 100vh;
    min-height: -webkit-fill-available;
    z-index: 9999999999991;
    cursor: pointer;
    background: rgba($color: #000000, $alpha: 0.3);
  }
  .modal {
    width: 40%;
    height: auto;
    min-width: 320px;
    background: #fff;
    z-index: 992;
    border-radius: 25px;
    padding: 50px;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .Verify {
      margin-top: 20px;
      .code {
        display: flex;
        justify-content: center;
        input {
          margin-left: 10px;
          margin-right: 10px;
          height: 50px;
          width: 50px;
          border: 1px solid var(--primary);
          color: var(--primary);
          border-radius: 5px;
          text-align: center;
          font-size: 15px;
        }
      }
    }
    .group {
      b {
        color: var(--primary);
        font-size: 16px;
        font-size: 900;
        margin-bottom: 10px;
        display: block;
      }
      input {
        width: 100%;
        height: 40px;
        padding: 0 20px;
        border: 1px solid #ccc;
        border-radius: 5px;
        font-size: 14px;
        letter-spacing: 1px;
      }
    }
    .footer {
      text-align: center;
      margin-top: 20px;
      .text {
        color: #555;
        font-size: 14px;
      }
      button {
        background: var(--primary);
        color: var(--primary-font);
        padding: 15px 50px;
        border-radius: 100px;
        letter-spacing: 1px;
        margin-top: 20px;
        font-size: 15px;
      }
      button:hover {
        background: var(--primary-hover);
      }
    }
  }
  .RegisterModal {
    display: none;
  }
  @media only screen and (max-width: 900px) {
    .modal {
      padding: 50px 20px !important;
      width: 95% !important;
      min-width: unset;
      .Verify {
        .code {
          input {
            width: 40px;
            height: 40px;
            margin-left: 5px;
            margin-right: 5px;
          }
        }
      }
    }
  }
}
</style>
